export abstract class UserService {
  abstract createUserIfNotExists(): Promise<string>;

  abstract getUserId(): Promise<string | undefined>;
}
